module.exports = __webpack_public_path__ + "static/media/Intersect-3.46a2e23b.svg";